<template>
  <formulaire-view :steps="steps" :step="step" url="/demande-enregistrement-societe/" paramsName="enregistrement_societe" :endpoint="endpoint" showPanier :getRefs="$refs">
    <template v-slot:step="{ sas, path, setState, code }">
      <component :is="path" :sas="sas" @validation-changed="setState(path, $event)" :ref="path" :endpoint="endpoint">
        <ressource :code="code" />
      </component>
    </template>
  </formulaire-view>
</template>

<script>
import FormulaireView from "@/views/FormulaireView.vue"

import Achat from "@/components/Formulaires/DemandeEnregistrementSociete/Achat.vue"
import Actionnaire from "@/components/Formulaires/DemandeEnregistrementSociete/Actionnaire.vue"
import Declaration from "@/components/Formulaires/DemandeEnregistrementSociete/Declaration.vue"
import Ouverture from "@/components/Formulaires/DemandeEnregistrementSociete/Ouverture.vue"
import Societe from "@/components/Formulaires/DemandeEnregistrementSociete/Societe.vue"

export default {
  props: {
    step: String
  },
  data() {
    return {
      endpoint: "demande-enregistrement-societe",
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "societe", code: "titre-etape-1", state: "" },
        { path: "actionnaire", code: "titre-etape-2", state: "" },
        { path: "ouverture", code: "titre-etape-3", state: "" },
        { path: "achat", code: "titre-etape-4", state: "" },
        { path: "declaration", code: "titre-etape-5", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    FormulaireView,
    Achat,
    Actionnaire,
    Declaration,
    Ouverture,
    Societe
  }
}
</script>